import styled from 'styled-components';
import { Text, FlexColumn, FlexRow } from '@make-software/tg-mini-app-ui';

export const Card = styled(FlexColumn)`
  width: 100%;
  border-radius: 16px;
  border: 1px solid #41424e;
  color: #fff;
  margin-top: 15px;
`;

export const Header = styled(FlexRow)`
  padding: 12px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #404249;
  background: #3a3b46;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
`;

export const HeaderTitle = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.28px;
  line-height: 140%;
  font-family: 'Inter';
`;

export const HeaderProgress = styled.div`
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
`;

export const ProgressCurrent = styled.span<{ completed?: boolean }>`
  color: ${({ completed = false }) => (completed ? '#FFF' : '#31de91')};
  font-size: 14px;
  font-weight: ${({ completed = false }) => (completed ? 500 : 700)};
  line-height: 140%;
`;

export const Body = styled.div`
  padding: 20px;
  background: #30313b;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

export const TaskRow = styled(FlexRow)<{ completed?: boolean }>`
  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const IconCircle = styled.div<{ active?: boolean }>`
  width: 17px;
  height: 17px;
  min-width: 17px;
  border-radius: 50%;
  border: 2px solid ${({ active }) => (active ? '#4cd964' : '#8e8e93')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const TaskText = styled.p<{ completed?: boolean }>`
  margin: 0;
  font-size: 15px;
  line-height: 1.4;
  color: ${({ completed }) => (completed ? '#31DE91' : '#A9AAAD')};
`;

export const TaskStrong = styled.span`
  font-weight: 600;
`;

export const RoundContainer = styled(FlexColumn)<{ padding?: string }>(({ theme, padding }) =>
  theme.withMedia({
    padding: padding || '20px 17px 32px 17px',
    backgroundColor: '#1C1D24',
    alignSelf: 'stretch',
    marginTop: '20px'
  })
);
